import { render } from "./long-insure-bills.vue?vue&type=template&id=f53e6660&scoped=true&ts=true"
import script from "./long-insure-bills.vue?vue&type=script&lang=ts"
export * from "./long-insure-bills.vue?vue&type=script&lang=ts"

import "./long-insure-bills.vue?vue&type=style&index=0&id=f53e6660&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53e6660"]])

export default __exports__